import React, { useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { updateProcurement } from "../../../services/api/procurementService";
import SpinnerIcon from "../../../assets/icons/spinner";
import { adminsSelection } from "../../../services/data/users";
import { ProcurementType } from "../../../helpers/procurementHelper";
import StatusBadge from "../../../components/ui/StatusBadge";
import Button from "../../../components/ui/Button";
import SelectInput from "../../../components/ui/inputs/SelectInput";

export default function SelectAdmin() {
  const { procurement, handleUpdateProcurement } = useOutletContext();
  const { uuidProcurement } = useParams();
  const [isUpdatingParams, setIsUpdatingParams] = useState(false);
  const [isChangingAdmin, setIsChangingAdmin] = useState(false);
  const [uuidSelectedAdmin, setUuidSelectedAdmin] = useState(
    procurement.type === ProcurementType.MEDIUM
      ? procurement.boardCanApprove[1].uuid
      : null,
  );

  const saveButtonIsDisabled
    = procurement.type !== ProcurementType.MEDIUM
    || isChangingAdmin
    || isUpdatingParams;

  async function updateSelectedAdmin() {
    try {
      setIsChangingAdmin(true);
      await updateProcurement(uuidProcurement, {
        selectAdmin: uuidSelectedAdmin,
      });
    } catch {
      throw Error("Impossible d'enregistrer l'administrateur sélectionné.");
    } finally {
      setIsChangingAdmin(false);
    }
  }

  async function updateParams() {
    try {
      setIsUpdatingParams(true);
      if (uuidSelectedAdmin !== procurement.boardCanApprove[1].uuid) {
        await updateSelectedAdmin();
      }
      await handleUpdateProcurement();
      toast.success("Changement enregistré");
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsUpdatingParams(false);
    }
  }

  return (
    <div className="flex flex-col space-y-6 h-full">
          <div className="flex flex-col space-y-2 h-full">
            {procurement.type === ProcurementType.MEDIUM
              ? (
                <div className="flex items-end space-x-4">
                  <div className="w-96">
                    <SelectInput
                      id="admin-selected"
                      disabled={isChangingAdmin}
                      label="Administrateur sélectionné"
                      onChange={setUuidSelectedAdmin}
                      placeholder="Sélectionner un administrateur"
                      helper="L'administrateur sélectionné pourra accéder au marché et l'approuver au même titre que le président du CA."
                      value={uuidSelectedAdmin}
                      options={adminsSelection}
                      required
                    />
                  </div>
                  {isChangingAdmin && (
                    <div className="w-11 self-center">
                      <SpinnerIcon />
                    </div>
                  )}
                </div>
              )
              : (
                <div className="h-full flex justify-center items-center">
                  <StatusBadge
                    text="Aucun paramètre disponible pour ce marché"
                    color="orange"
                  />
                </div>
              )}
          </div>
          {procurement.type === ProcurementType.MEDIUM && (
            <Button onClick={() => updateParams()} disabled={saveButtonIsDisabled}>
              Enregistrer les modifications
            </Button>
          )}
    </div>
  );
}
